import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledComponent = styled(({css, ...rest}) => <pre {...rest} />)`
  display: block;
  border: ${p => p.theme.border_line};
  padding: ${p => p.theme.xs};
  border-color: rgba(167,0,0,0.89);

  &:before {
    content: 'Component Error Stack';
    display: block;
    font-size: 1.42em;
  }
  ${p => p.css}
`

const _ErrorComponentStack = (props) => <StyledComponent {...props} />
_ErrorComponentStack.propTypes = {
  css: PropTypes.string,
}

export default _ErrorComponentStack

